import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/YoutubeCompareAllPostsInDate.graphql';
import { Query, QueryyoutubeCompareAllPostsInDateArgs } from '../../__generated__/globalTypes';

export const useYoutubeCompareAllPostsInDateQuery = (
  options?: QueryHookOptions<Query, QueryyoutubeCompareAllPostsInDateArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryyoutubeCompareAllPostsInDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useYoutubeCompareAllPostsInDateLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryyoutubeCompareAllPostsInDateArgs>
): QueryResult<Query, QueryyoutubeCompareAllPostsInDateArgs> & {
  getYoutubeCompareAllPostsInDate: LazyQueryExecFunction<Query, QueryyoutubeCompareAllPostsInDateArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getYoutubeCompareAllPostsInDate, result] = useLazyQuery<Query, QueryyoutubeCompareAllPostsInDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getYoutubeCompareAllPostsInDate, ...result };
};

export const useYoutubeCompareAllPostsInDatePromiseQuery = () => {
  const client = useApolloClient();

  const getYoutubeCompareAllPostsInDate = useCallback(
    (options?: Omit<QueryOptions<QueryyoutubeCompareAllPostsInDateArgs, Query>, 'query'>) =>
      client.query<Query, QueryyoutubeCompareAllPostsInDateArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getYoutubeCompareAllPostsInDate };
};
// Suspense Query Hooks
export const useYoutubeCompareAllPostsInDateSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryyoutubeCompareAllPostsInDateArgs>
) => {
  const result = useSuspenseQuery<Query, QueryyoutubeCompareAllPostsInDateArgs>(QUERY, {
    ...options
  });

  return result;
};
